interface Props {
  onClick: () => void;
  size?: number;
}

const BlackCloseButton = ({ onClick, size = 20 }: Props) => (
  <button
    type="button"
    onClick={onClick}
    style={{ cursor: 'pointer', background: 'none', border: 'none', padding: 0, display: 'flex', alignItems: 'center', flexShrink: 0 }}
  >
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="#171717" />
      <line x1="7.5" y1="7.5" x2="16.5" y2="16.5" stroke="white" strokeWidth="1.75" strokeLinecap="round" />
      <line x1="16.5" y1="7.5" x2="7.5" y2="16.5" stroke="white" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  </button>
);

export default BlackCloseButton;
